/*********************************************************
 * Third Components
*********************************************************/
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

/*********************************************************
 * Components
*********************************************************/
import Modal, { ModalBody } from 'Components/Modal';
import Tabs, { TabContainer } from 'Components/Tabs';
import LandmarkListEdit from '../LandmarkListEdit'
import LandmarkGroupListEdit from '../LandmarkGroupListEdit'
import ModalDeleteLandmarkGroup from './ModalDeleteLandmarkGroup'
import ModalEditLandmarkGroup from './ModalEditLandmarkGroup'
import ModalEditLandmark from './ModalEditLandmark'
import ModalBulkDeleteLandmarks from './ModalBulkDeleteLandmarks'
import ModalBulkEditLandmarks from './ModalBulkEditLandmarks'
import { NotificationManager } from 'Components/Notifications';

/*********************************************************
 * Redux
*********************************************************/
import {
  showModalManageLandmark,
  mapLandmarkGetLandmarkGroups,
  landmarkRestarProcess
} from 'Redux/actions';

/*********************************************************
 * Css
*********************************************************/
import './style.scss'

/*********************************************************
 * Class to show modal elements
*********************************************************/
const ModalManageLandmark = (props) => {

  const { messages } = props;  
  const [tabIndex, setTabIndex] = useState(0);
  const dispatch = useDispatch();

  /*********************************************************
   * Import redux properties
  *********************************************************/
  const {
    smodalManageLandmark,
    process
  } = useSelector((state) => state.realtimeMapLandmarkModuleRedux);


  /*********************************************************
  * Show message when save or update elements
  *********************************************************/
  useEffect(()=> {
    if(process && smodalManageLandmark){
      NotificationManager.success(
        messages['realtimemaps_landmark_manage_landmarks'],
        messages['success'],
        3000,
        null,
        null,
        'success',
      );
      dispatch(landmarkRestarProcess())
    }
  }, [process])

  /*********************************************************
   * Close modal
  *********************************************************/
  const onHandleClose = (value) => dispatch(showModalManageLandmark(value))
  
  return(

    <Modal
      title={messages["realtimemaps_landmark_manage_landmarks"]}
      open={smodalManageLandmark || false}
      handleClose={()=> {
        onHandleClose(false) 
      }}
      size="large"
      className="overflow-x-hidden"
    >
      <ModalBody>
        <ModalEditLandmark messages={messages} />
        <ModalBulkEditLandmarks messages={messages} />
        <ModalBulkDeleteLandmarks messages={messages} />
        <ModalDeleteLandmarkGroup messages={messages} />
        <ModalEditLandmarkGroup messages={messages} />
        <div className='modalManageLandmark'>
          <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={0}>
            <Grid item xs={12}>
              <Tabs
                tab={tabIndex}
                onChange={(e) => setTabIndex(e) }
              >
                <TabContainer className='modalTabLandmark' label={messages['realtimemaps_landmarks']} index={0}>
                  <LandmarkListEdit messages={messages} />
                </TabContainer>
                <TabContainer className='modalTabLandmark' label={messages['realtimemaps_landmarks_groups']} index={1}>
                  <LandmarkGroupListEdit messages={messages} />
                </TabContainer>
              </Tabs>
            </Grid>
          </Grid>
        </div>
      </ModalBody>
    </Modal>
  )

}

export default ModalManageLandmark